// @flow
import * as React from 'react'

type Props = {
  render: Function,
  focusOnRemount?: boolean,
}

type Focusable = {
  focus?: Function,
}

/**
 * Component that searches for rendered element with prop "autofocus"
 * and sets it active
 */
class AutofocusElement extends React.Component<Props> {
  static defaultPrps = {
    focusOnRemount: false,
  }

  autofocusElem = null

  needRestoreFocus = false

  componentDidMount() {
    this.setFocus()
  }

  UNSAFE_componentWillUpdate() {
    const { focusOnRemount } = this.props
    if (focusOnRemount && document.activeElement === this.autofocusElem) {
      this.needRestoreFocus = true
    }
  }

  componentDidUpdate() {
    if (this.needRestoreFocus && document.activeElement === document.body) {
      this.setFocus()
    }
  }

  setFocus() {
    if (this.autofocusElem && this.autofocusElem.focus) {
      this.autofocusElem.focus()
      this.needRestoreFocus = false
    }
  }

  setFocusableRef = (component: Focusable) => {
    this.autofocusElem = component
  }

  render() {
    return this.props.render({ setFocusableRef: this.setFocusableRef })
  }
}

export default AutofocusElement
